import {Component, OnInit} from '@angular/core';
import {HcaHistoryChangesService} from '../../../../../../shared/_services/hca-history-changes.service';
import {FormControl, FormGroup} from '@angular/forms';

@Component({
  selector: 'app-hca-history-changes-list',
  templateUrl: './hca-history-changes-list.component.html',
  styleUrls: ['./hca-history-changes-list.component.scss']
})
export class HcaHistoryChangesListComponent implements OnInit {
  logs = [];
  form: FormGroup;
  entities = [];

  constructor(
    private hcaHistoryChangesService: HcaHistoryChangesService
  ) {
    this.form = new FormGroup({
      entity: new FormControl(),
      id: new FormControl(),
      who: new FormControl(),
      timestamp_from: new FormControl(),
      timestamp_to: new FormControl()
    });
  }

  searchLogs() {
    const raw = this.form.getRawValue();
    this.hcaHistoryChangesService.searchLogs(JSON.stringify(raw)).subscribe(
      res => {
          this.logs = res;
      }, error => {
        console.error(error);
      });
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/settings/hca-history-changes/hca-history-changes-list/hca-history-changes-list.component.ts